export enum ErrorTypes {
  Flow = 0,
  Progress,
  Assets,
  StartFlow,
  Operations,
}
